import { Link } from 'react-router-dom';

const classMap = {
  gold:            'btn btn-gold',
  navy:            'btn btn-navy',
  'outline-light': 'btn btn-outline-light-custom',
  'outline-navy':  'btn btn-outline-navy',
};

function CTAButton({ type = 'gold', to = '/contact', href, children, external }) {
  const cls = classMap[type] ?? classMap.gold;
  if (external || href) {
    return (
      <a className={cls} href={href || to} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    );
  }
  return <Link className={cls} to={to}>{children}</Link>;
}

export default CTAButton;
